function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Tree Count
 *    Scripts to increment and update the tree count globally.
 *    Tree data from settings_schema is exposed to the window
 *    and used to calculate the updated tree total.
 *
 *  Version:
 *    1.0.0 - 2020/05/05
 */

import $ from 'jquery';
import { liquidToDate } from '@process-creative/slate-theme-tools';
export var TREE_COUNT_SELECTOR = 'data-tree-count';
export var OFFSET_TO_MS = 60000;
export var STATIC_TIMEZONE = -600;
export var INTERVAL_MINUTES = 15;

// Data attributes
export var ATTR_CO2_FACTOR = 'data-co2-factor';
export var ATTR_EMPLOYMENT_FACTOR = 'data-employment-factor';
export var TreeCount = /*#__PURE__*/function () {
  function TreeCount() {
    _classCallCheck(this, TreeCount);
    this.treeCountElement = $("[".concat(TREE_COUNT_SELECTOR, "]"));
    this.updated = [];
    if (this.treeCountElement.length) this.checkData();
  }
  _createClass(TreeCount, [{
    key: "checkData",
    value: function checkData() {
      var data = window.TreeData;
      if (!data || !data.count || !data.date || !data.increment) return;
      this.current = data.count;
      this.date = liquidToDate(data.date);
      this.increment = data.increment;
      this.targetTimezone = STATIC_TIMEZONE * OFFSET_TO_MS;
      this.calculateTotal();
    }
  }, {
    key: "calculateTotal",
    value: function calculateTotal() {
      var now = new Date(); //System Time
      var myTimezone = now.getTimezoneOffset() * OFFSET_TO_MS;
      var diff = now.getTime() + myTimezone - (this.date.getTime() + this.targetTimezone);

      //Error in calc, don't update values and leave as the data from the settings
      if (!diff || isNaN(diff)) return;
      var minutes = diff / 60000;
      var intervals = Math.floor(minutes / INTERVAL_MINUTES);
      this.current = this.current + intervals * this.increment;
      this.updateCounters();
    }
  }, {
    key: "updateCounters",
    value: function updateCounters() {
      var _this = this;
      var top = $(window).scrollTop();
      var bottom = top + $(window).height();
      this.treeCountElement.each(function (i, e) {
        var self = $(e);
        var sTop = self.offset().top;

        //Is the element in view? If so, update it
        if (sTop > top && sTop < bottom) {
          var type = self.attr(TREE_COUNT_SELECTOR);
          var co2Factor = self.attr(ATTR_CO2_FACTOR);
          var employmentFactor = self.attr(ATTR_EMPLOYMENT_FACTOR);
          if (type === 'co2-offset') {
            self.html(parseInt(_this.current * co2Factor));
          } else if (type === 'employment-offset') {
            self.html(parseInt(_this.current * employmentFactor));
          } else {
            self.html(_this.current);
          }
          if (_this.updated.indexOf(i) == -1) _this.updated.push(i);
        }
      });

      //All have been updated, no longer need to RAF
      if (this.updated.length == this.treeCountElement.length) return;
      requestAnimationFrame(function () {
        return _this.updateCounters();
      });
    }
  }]);
  return TreeCount;
}();